import PropTypes from 'prop-types';
import { BsCheckLg, BsArrowReturnLeft } from 'react-icons/bs';
import { AiOutlineReload } from 'react-icons/ai';
import { Input } from 'ypf-pas-general-ui-components';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import {
  OWSincronizationStatus,
  workReportLineStatus as workLinesString
} from '../../../constants/constants';
import { Line } from '../../../utils/globalPropTypes';
import { ubicationTypeEnum, workReportLineStatus } from '../../../utils/dataStatus';
import color from '../../../styles/colors.module.scss';
import { checkRol } from '../../../security';
import { notificador, proveedorNotificador } from '../../../security/constantsRols';

const STATES_WITH_ICONS_OW = [
  workReportLineStatus.devolver,
  workReportLineStatus.fijar,
  workReportLineStatus.aprobar
];

const AmountInput = (props) => {
  const {
    isOyM,
    line,
    onChange,
    value,
    colors,
    disabled,
    forceEnabled,
    disabledEditStateCancelOrFinish,
    typeOfUbication,
    notificaPP
  } = props;

  // Open Wells states
  const isChecked = line?.iconoSincronizacionEnum === OWSincronizationStatus.check;
  const isSynchronizing = line?.iconoSincronizacionEnum === OWSincronizationStatus.sincronizacion;
  const isReturned = line?.iconoSincronizacionEnum === OWSincronizationStatus.devolver;

  const visualizeOWStatus = STATES_WITH_ICONS_OW.includes(line.estadoEnum);

  const showProgramPointButton =
    checkRol(proveedorNotificador) &&
    (typeOfUbication?.id === ubicationTypeEnum.pozo ||
      typeOfUbication?.id === ubicationTypeEnum.locacion) &&
    notificaPP;

  const setInputBackgroundColor = () => {
    if ((colors || line.colores) === '#FFFFFF,#219E66') return 'backgroundGreen';
    if ((colors || line.colores) === '#FFFFFF,#159AD8') return 'backgroundBlue';
    if ((colors || line.colores) === '#000000,#FFFFFF') return 'default';
    if ((colors || line.colores) === '#999999,#DDDDDD') return 'backgroundGrey';

    return 'transparent';
  };

  const setInputColor = () => {
    if ((colors || line.colores) === '#219E66,#FFFFFF') return 'colorGreen';
    if ((colors || line.colores) === '#FFFFFF,#FF6666') return 'colorRed';
    if ((colors || line.colores) === '#000000,#FFFFFF') return 'colorBlack';
    if ((colors || line.colores) === '#999999,#DDDDDD') return 'colorGrey';

    return 'default';
  };

  const setIconOW = () => {
    if (visualizeOWStatus && !isOyM) {
      if (isChecked) return <BsCheckLg />;
      if (isSynchronizing) return <AiOutlineReload />;
      if (isReturned) return <BsArrowReturnLeft />;
    }

    return null;
  };

  // Si es pendiente para ese dia se ha cargado los partes por la App
  // no se permite cargar cantidad de otra lineas
  const tooltipStatus =
    line.flujoMobile && line.estadoEnum === workReportLineStatus.pendiente
      ? 'Bloqueada'
      : workLinesString[line.estadoEnum];

  return (
    <OverlayTrigger
      delay={{
        show: 250,
        hide: 400
      }}
      overlay={
        <Tooltip id="button-tooltip">
          {`${tooltipStatus}
          ${visualizeOWStatus && isSynchronizing && !isOyM ? ' - Sincronizando' : ''}`}
        </Tooltip>
      }
      placement="top"
    >
      <div>
        <Input
          backgroundColor={disabled ? color.$lightGray : setInputBackgroundColor()}
          color={setInputColor()}
          disabled={
            (line.disabled ||
              line.flujoMobile ||
              (showProgramPointButton && line.tienePuntosPrograma) ||
              disabled ||
              disabledEditStateCancelOrFinish ||
              !(checkRol(proveedorNotificador) || checkRol(notificador))) &&
            !forceEnabled
          }
          errors=""
          icon={setIconOW()}
          min={0}
          name={`amount${line.idParteDiario}`}
          onChange={(val) => onChange(val)}
          placeholder="-"
          type="number"
          value={
            value === null || (value === 0 && line?.estadoEnum === workReportLineStatus.pendiente)
              ? ''
              : value
          }
          widthDateInput="100%"
        />
      </div>
    </OverlayTrigger>
  );
};

AmountInput.propTypes = {
  isOyM: PropTypes.bool,
  line: Line.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.string,
  disabled: PropTypes.bool,
  forceEnabled: PropTypes.bool,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  typeOfUbication: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }),
  notificaPP: PropTypes.bool
};

AmountInput.defaultProps = {
  isOyM: false,
  value: null,
  colors: undefined,
  disabled: false,
  forceEnabled: false,
  typeOfUbication: {
    id: 0,
    nombre: ''
  },
  notificaPP: false
};

export default AmountInput;
